export default "__VITE_ASSET__1Bc9wGAS__"